<template>
  <div class="energy">
    <div class="content">
      <div class="row">
        <div class="col-md-6 detail-info-box">
          <h1>Energy Overview</h1>
          <p>
            The energy sector is the second largest contributing sector to
            global emissions of non-CO₂ GHGs, accounting for 29% of global
            non-CO₂ emissions in 2015. Global energy-sector CH₄ and N₂O
            historical and projected emissions and the mitigation potential are
            estimated for the following source categories:
          </p>
          <ul>
            <li>Coal mining (CH₄)</li>
            <li>Natural gas and oil systems (CH₄)</li>
            <li>Combustion of fossil fuels and biomass (CH₄, N₂O)</li>
          </ul>

          <div class="tabs">
            <b-tabs content-class="mt-2">
              <b-tab title="Emission Projections" active>
                <p>
                  Energy sector emissions increased 29% between 1990 and 2015. Between
                  2015 and 2030, global energy-sector emissions are projected to
                  increase 4% under a BAU scenario, reaching 3,585 MtCO₂e in 2030,
                  Natural gas and oil activities are projected to remain the largest
                  contributor to non-CO₂ emissions from the energy sector; stationary
                  and mobile combustion emissions are projected to grow 15% between
                  2015 and 2030, thereby surpassing coal mining emissions as the
                  second largest contributor for this sector. Emissions from coal
                  mining activities are projected to decrease by 6% between 2015 and
                  2030 as the energy sector transitions from coal to natural gas.
                </p>
              </b-tab>
              <b-tab title="Mitigation Assessments">
                <p>
                  Mitigation potential from the energy sector is approximately 1,265
                  MtCO₂e in 2030, accounting for 64% of coal emissions and 38% of oil
                  and gas emissions. Mitigation potential in the energy sector
                  represents 33% of total global non-CO₂ mitigation potential in 2030.
                </p>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="col-md-6">
          <Chart />

          <div class="row">
            <div class="col-sm-12">
              <p>
                <strong class="space-right-25">Explore Energy Sectors:</strong>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button type="button" @click="openDialogFromPage3">Coal Mining</button>
              <button type="button" @click="openDialogFromPage4">Oil and Natural Gas Systems</button>
              <button
                type="button"
                @click="openDialogFromPage5"
              >Combustion of Fossil Fuels and Biomass</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a11y-dialog
      id="main-dialog3"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference3"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <CoalMining />
      </div>
    </a11y-dialog>
    <a11y-dialog
      id="main-dialog4"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference4"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <OilNaturalGas />
      </div>
    </a11y-dialog>
    <a11y-dialog
      id="main-dialog5"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference5"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <FossilBiomass />
      </div>
    </a11y-dialog>
  </div>
</template>

<script>
import CoalMining from "@/components/energy/CoalMining";
import FossilBiomass from "@/components/energy/FossilBiomass";
import OilNaturalGas from "@/components/energy/OilNaturalGas";
import Chart from "./ChartEnergy";

export default {
  name: "EnergyScreen",
  components: {
    CoalMining,
    FossilBiomass,
    OilNaturalGas,
    Chart
  },
  props: {
    msg: String
  },
  data() {
    return {
      dialog3: null,
      dialog4: null,
      dialog5: null
    };
  },

  methods: {
    goToPage: function(a) {
      if (a) {
        location.href = "#/energy/" + a;
      }
    },
    assignDialogReference3(dialog3) {
      this.dialog3 = dialog3;
    },
    assignDialogReference4(dialog4) {
      this.dialog4 = dialog4;
    },
    assignDialogReference5(dialog5) {
      this.dialog5 = dialog5;
    },
    openDialogFromPage3() {
      if (this.dialog3) {
        this.dialog3.show();
      }
    },
    openDialogFromPage4() {
      if (this.dialog4) {
        this.dialog4.show();
      }
    },
    openDialogFromPage5() {
      if (this.dialog5) {
        this.dialog5.show();
      }
    }
  },
  computed: {
    useFallback() {
      return typeof window.HTMLDialogElement !== "function";
    }
  }
};
</script>
<style scoped>
h1 {
  font-weight: normal;
  font-size: 2rem;
  margin-bottom: 1rem;
}

.content {
  padding-left: 150px;
  padding-right: 150px;
}

.placeholder {
  width: 80%;
  height: 80%;
  background-color: #ececec;
  margin: 10%;
}
img {
  margin-left: 3rem;
}

@media all and (max-width: 1280px) {
  .content {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media all and (max-width: 980px) {
  .energy {
    background-position: 0 -40px;
  }
  .content {
    margin-top: 70px;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media all and (max-width: 736px) {
  h1 {
    font-size: 1.5rem;
  }
  .energy {
    position: static;
  }
}
</style>
